import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
//import Fragment from 'vue-fragment';
import VueGtag from "vue-gtag";
import Hotjar from 'vue-hotjar'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'


Vue.use(BootstrapVue, {
  breakpoints: [`xs`, 'sm', 'md', 'lg', 'xl', 'xxl']
})
Vue.use(IconsPlugin)
//Vue.use(Fragment.Plugin)

Vue.use(VueGtag, {
  config: { id: "G-YEFLMJX9X4" }
});
Vue.use (Hotjar, {
  id: '2860777',
})

import "./assets/scss/style.scss";
import "./assets/scss/bootstrap.scss";

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')